export const ALLOWED_CHANNELS = {
    WEB: 'WEB',
    APP: 'APP',
};
export const TEMPLATE_ACTION_REDUX = 'TEMPLATE_ACTION_REDUX';
export const TEMPLATE_ACTION_GET_MENU = 'TEMPLATE_ACTION_GET_MENU';
export const TEMPLATE_API_SUCCESS = 'TEMPLATE_API_SUCCESS';
export const TEMPLATE_ERROR_SHOW = 'TEMPLATE_ERROR_SHOW';
export const TEMPLATE_ERROR_CLOSE = 'TEMPLATE_ERROR_CLOSE';
export const TEMPLATE_SPINNER_SHOW = 'TEMPLATE_SPINNER_SHOW';
export const SET_ON_PRE_30_MIN_POPUP_SCREENCHECK = 'SET_ON_PRE_30_MIN_POPUP_SCREENCHECK';
export const TEMPLATE_SPINNER_HIDE = 'TEMPLATE_SPINNER_HIDE';
export const GET_CONTENT = 'GET_CONTENT';
export const NAVIGATION_LINK_CONTENT = {
    GET_CONTENT: 'GET_NAVIGATION_LINK_CONTENT',
    GET_CONTENT_SUCCESS: 'GET_NAVIGATION_LINK_CONTENT_SUCCESS',
    GET_CONTENT_ERROR: 'GET_NAVIGATION_LINK_CONTENT_ERROR',
};
export const SETLOCATION_NAVIGATION = 'isNavigateFromPromos';
export const CONTENT_API_SUCCESS = 'CONTENT_API_SUCCESS';
export const CONTENT_API_ERROR = 'CONTENT_API_ERROR';
export const APP_CHECK_ACTIONS = 'APP_CHECK_ACTIONS';
export const LOAD_APP_CONFIG_SUCCESS = 'LOAD_APP_CONFIG_SUCCESS';
export const OFFER_AND_DEALS_ACTION = 'OFFER_AND_DEALS_ACTION';
export const OFFER_AND_DEALS_SUCCESS = 'OFFER_AND_DEALS_SUCCESS';
export const OFFER_AND_DEALS_ERROR = 'OFFER_AND_DEALS_ERROR';
export const GET_MARKET_CONFIG_CONTENT = 'GET_MARKET_CONFIG_CONTENT';
export const ADD_NEW_ADDRESS = 'ADD_NEW_ADDRESS';
export const MARKET_CONFIG_CONTENT_API_SUCCESS = 'MARKET_CONFIG_CONTENT_API_SUCCESS';
export const MARKET_CONFIG_CONTENT_API_ERROR = 'MARKET_CONFIG_CONTENT_API_ERROR';
export const GET_MORE_CONTENT = 'GET_MORE_CONTENT';
export const MORE_CONTENT_API_SUCCESS = 'MORE_CONTENT_API_SUCCESS';
export const MORE_CONTENT_API_ERROR = 'MORE_CONTENT_API_ERROR';
export const PLACES_AUTOCOMPLETE_ACTION = 'PLACES_AUTOCOMPLETE_ACTION';
export const PLACES_AUTOCOMPLETE_SUCCESS = 'PLACES_AUTOCOMPLETE_SUCCESS';
export const PLACES_AUTOCOMPLETE_CLEAR = 'PLACES_AUTOCOMPLETE_CLEAR';
export const PLACES_AUTOCOMPLETE_ERROR = 'PLACES_AUTOCOMPLETE_ERROR';
export const PLACES_GEOLOCATION_ACTION = 'PLACES_GEOLOCATION_ACTION';
export const PLACES_GEOLOCATION_SUCCESS = 'PLACES_GEOLOCATION_SUCCESS';
export const PLACES_GEOLOCATION_ERROR = 'PLACES_GEOLOCATION_ERROR';
export const PLACES_REVERSE_GEOCODE_ACTION = 'PLACES_REVERSE_GEOCODE_ACTION';
export const PLACES_REVERSE_GEOCODE_SUCCESS = 'PLACES_REVERSE_GEOCODE_SUCCESS';
export const PLACES_REVERSE_GEOCODE_FAILURE = 'PLACES_REVERSE_GEOCODE_FAILURE';
export const RESET_AUTOCOMPLETE = 'RESET_AUTOCOMPLETE';
export const NEARBY_STORES = 'NEARBY_STORES';
export const NEARBY_STORES_SUCCESS = 'NEARBY_STORES_SUCCESS';
export const NEARBY_STORES_ERROR = 'NEARBY_STORES_ERROR';
export const DISTANCE_GOOGLE_API = 'DISTANCE_GOOGLE_API';
export const DISTANCE_GOOGLE_API_SUCCESS = 'DISTANCE_GOOGLE_API_SUCCESS';
export const DISTANCE_GOOGLE_API_ERROR = 'DISTANCE_GOOGLE_API_ERROR';
export const STORE_STATUS = 'STORE_STATUS';
export const STORE_STATUS_SUCCESS = 'STORE_STATUS_SUCCESS';
export const STORE_STATUS_ERROR = 'STORE_STATUS_ERROR';
export const FAVORITE_STORE_STATUS = 'FAVORITE_STORE_STATUS';
export const FAVORITE_STORE_STATUS_SUCCESS = 'FAVORITE_STORE_STATUS_SUCCESS';
export const FAVORITE_STORE_STATUS_ERROR = 'FAVORITE_STORE_STATUS_ERROR';
export const GET_RESTAURANT_DETAILS = 'GET_RESTAURANT_DETAILS';
export const GET_RESTAURANT_DETAILS_SUCCESS = 'GET_RESTAURANT_DETAILS_SUCCESS';
export const GET_RESTAURANT_DETAILS_FAILURE = 'GET_RESTAURANT_DETAILS_FAILURE';
export const GET_CONTACT_US_RESTAURANT_DETAILS = 'GET_CONTACT_US_RESTAURANT_DETAILS';
export const GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS = 'GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS';
export const GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE = 'GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE';
export const GET_STORE_DETAILS = 'GET_STORE_DETAILS';
export const GET_STORE_DETAILS_SUCCESS = 'GET_STORE_DETAILS_SUCCESS';
export const GET_STORE_DETAILS_FAILURE = 'GET_STORE_DETAILS_FAILURE';
export const GET_DELIVERY_LOCATION_LOCALIZATION = 'GET_DELIVERY_LOCATION_LOCALIZATION';
export const GET_DELIVERY_LOCATION_LOCALIZATION_FAILURE = 'GET_DELIVERY_LOCATION_LOCALIZATION_FAILURE';
export const GET_DELIVERY_LOCATION_LOCALIZATION_SUCCESS = 'GET_DELIVERY_LOCATION_LOCALIZATION_SUCCESS';
export const GET_STORE_ORDER_CAPACITY = 'GET_STORE_ORDER_CAPACITY';
export const GET_STORE_ORDER_CAPACITY_FAILURE = 'GET_STORE_ORDER_CAPACITY_FAILURE';
export const GET_STORE_ORDER_CAPACITY_SUCCESS = 'GET_STORE_ORDER_CAPACITY_SUCCESS';
export const RESET_STORE_ORDER_CAPACITY = 'RESET_STORE_ORDER_CAPACITY';
export const RESET_STORES = 'RESET_STORES';
export const RESET_RESTAURANT = 'RESET_RESTAURANT';
export const SHOW_INDULGENT_ADDONS = 'SHOW_INDULGENT_ADDONS';
export const HIDE_INDULGENT_ADDONS = 'HIDE_INDULGENT_ADDONS';
export const SAVE_USER_PARAMS = 'SAVE_USER_PARAMS';
export const GET_PAST_ORDERS = 'GET_PAST_ORDERS'; // REMOVE AFTER FETCH_CUSTOMER_INFO INTEGRATION
export const SAVE_PAST_ORDERS_REDUCER = 'SAVE_PAST_ORDERS_REDUCER'; // REMOVE AFTER FETCH_CUSTOMER_INFO INTEGRATION
export const GET_ORDERLOOKUOP_CONTENT = 'GET_ORDERLOOKUOP_CONTENT';
export const ORDERLOOKUOP_CONTENT_API_SUCCESS = 'ORDERLOOKUOP_CONTENT_API_SUCCESS';
export const ORDERLOOKUOP_CONTENT_API_ERROR = 'ORDERLOOKUOP_CONTENT_API_ERROR';
export const FETCH_CUSTOMER_DETAILS = 'FETCH_CUSTOMER_DETAILS';
export const FETCH_CUSTOMER_INFO_SUCCESS = 'FETCH_CUSTOMER_INFO_SUCCESS';
export const FETCH_CUSTOMER_DETAILS_SUCCESS = 'FETCH_CUSTOMER_DETAILS_SUCCESS';
export const FETCH_CUSTOMER_DETAILS_ERROR = 'FETCH_CUSTOMER_DETAILS_ERROR';
export const UPDATE_ISNEW_CUSTOMER = 'UPDATE_ISNEW_CUSTOMER';
export const UPDATE_CUSTOMER_INFO = 'UPDATE_CUSTOMER_INFO';
export const RESET_CUSTOMER_INFO = 'RESET_CUSTOMER_INFO';
export const UPDATE_CUSTOMER_INFO_SUCCESS = 'UPDATE_CUSTOMER_INFO_SUCCESS';
export const UPDATE_CUSTOMER_INFO_ERROR = 'UPDATE_CUSTOMER_INFO_ERROR';
export const DELETE_CUSTOMER_ACCOUNT = 'DELETE_CUSTOMER_ACCOUNT';
export const UPDATE_EXTERNAL_CUSTOMER_ID = 'UPDATE_EXTERNAL_CUSTOMER_ID';
export const DELETE_CUSTOMER_ACCOUNT_SUCCESS = 'DELETE_CUSTOMER_ACCOUNT_SUCCESS';
export const DELETE_CUSTOMER_ACCOUNT_ERROR = 'DELETE_CUSTOMER_ACCOUNT_ERROR';
export const FETCH_RECOMMENDATIONS = 'FETCH_RECOMMENDATIONS'; // MENU RECOMMENDATION
export const FETCH_RECOMMENDATIONS_SUCCESS = 'FETCH_RECOMMENDATIONS_SUCCESS';
export const FETCH_RECOMMENDATIONS_ERROR = 'FETCH_RECOMMENDATIONS_ERROR';
export const STORE_AVAILABLE_TIME_SLOTS_REQUEST = 'STORE_AVAILABLE_TIME_SLOTS_REQUEST';
export const STORE_AVAILABLE_TIME_SLOTS_SUCCESS = 'STORE_AVAILABLE_TIME_SLOTS_SUCCESS';
export const STORE_AVAILABLE_TIME_SLOTS_FAILURE = 'STORE_AVAILABLE_TIME_SLOTS_FAILURE';
export const RESET_CART_FAILURE_EMPTY = 'RESET_CART_FAILURE_EMPTY';
export const STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST = 'STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST';
export const STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS = 'STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS';
export const STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE = 'STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE';
export const CREATE_BASKETS_REQUEST = 'CREATE_BASKETS_REQUEST';
export const CREATE_BASKETS_SUCCESS = 'CREATE_BASKETS_SUCCESS';
export const CREATE_BASKETS_FAILURE = 'CREATE_BASKETS_FAILURE';
export const CREATE_BASKETS_RESET = 'CREATE_BASKETS_RESET';
export const FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS = 'FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS'; // RECOMMENDED PRODUCTS FOR CUSTOMER IN HOME SCREEN
export const FETCH_MENU = 'FETCH_MENU'; // MENU RECOMMENDATION
export const FETCH_MENU_SUCCESS = 'FETCH_MENU_SUCCESS';
export const FETCH_MENU_SUCCESS_UNCHANGED = 'FETCH_MENU_SUCCESS_UNCHANGED';
export const FETCH_MENU_ERROR = 'FETCH_MENU_ERROR';
export const RESET_MENU = 'RESET_MENU';
export const GET_TENANT_CONFIG = 'GET_TENANT_CONFIG';
export const UPDATE_CURRENT_APP_VERSION = 'UPDATE_CURRENT_APP_VERSION';
export const UPDATE_TENANT_CONFIG = 'UPDATE_TENANT_CONFIG';
export const UPDATE_TENANT_CONFIG_SUCCESS = 'UPDATE_TENANT_CONFIG_SUCCESS';
export const UPDATE_TENANT_CONFIG_ERROR = 'UPDATE_TENANT_CONFIG_ERROR';
export const STORE_SCHEDULE_DATA = 'STORE_SCHEDULE_DATA';
export const GET_HELP_CONTENT = 'GET_HELP_CONTENT';
export const HELP_CONTENT_API_SUCCESS = 'HELP_CONTENT_API_SUCCESS';
export const HELP_CONTENT_API_ERROR = 'HELP_CONTENT_API_ERROR';
export const ADD_TO_CART_TOAST_CONTENT = 'ADD_TO_CART_TOAST_CONTENT';
export const ADD_TO_CART_TOAST_SUCCESS = 'ADD_TO_CART_TOAST_SUCCESS';
export const ADD_TO_CART_TOAST_ERROR = 'ADD_TO_CART_TOAST_ERROR';
export const HIDE_ADD_TO_CART_TOAST = 'HIDE_ADD_TO_CART_TOAST';
export const ITEM_UPDATED_TO_CART_SUCCESS = 'ITEM_UPDATED_TO_CART_SUCCESS';
export const ITEM_UPDATED_TO_CART_ERROR = 'ITEM_UPDATED_TO_CART_ERROR';
export const FETCH_ITEM_DETAILS = 'FETCH_ITEM_DETAILS';
export const FETCH_ITEM_DETAILS_SUCCESS = 'FETCH_ITEM_DETAILS_SUCCESS';
export const FETCH_ITEM_DETAILS_ERROR = 'FETCH_ITEM_DETAILS_ERROR';
export const GET_STORE_STATUS_ON_TIME = 'GET_STORE_STATUS_ON_TIME';
export const GET_STORE_STATUS_ON_TIME_SUCCESS = 'GET_STORE_STATUS_ON_TIME_SUCCESS';
export const GET_STORE_STATUS_ON_TIME_ERROR = 'GET_STORE_STATUS_ON_TIME_ERROR';
export const RESET_FULFILLMENT = 'RESET_FULFILLMENT';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const ADD_ITEM_TO_CART_SUCCESS = 'ADD_ITEM_TO_CART_SUCCESS';
export const ADD_ITEM_TO_CART_FAILURE = 'ADD_ITEM_TO_CART_FAILURE';
export const CART_DATA_ERROR_RESET = 'CART_DATA_ERROR_RESET';
export const DELETE_BASKET = 'DELETE_BASKET';
export const DELETE_BASKET_SUCCESS = 'DELETE_BASKET_SUCCESS';
export const DELETE_BASKET_FAILURE = 'DELETE_BASKET_FAILURE';
export const BASKET_DETAILS = 'BASKET_DETAILS';
export const BASKET_DETAILS_SUCCESS = 'BASKET_DETAILS_SUCCESS';
export const BASKET_DETAILS_FAILURE = 'BASKET_DETAILS_FAILURE';
export const UPDATE_ITEM_QUANTITY = 'UPDATE_ITEM_QUANTITY';
export const UPDATE_ITEM_QUANTITY_SUCCESS = 'UPDATE_ITEM_QUANTITY_SUCCESS';
export const UPDATE_ITEM_QUANTITY_FAILURE = 'UPDATE_ITEM_QUANTITY_FAILURE';
export const REMOVE_LINE_ITEM = 'REMOVE_LINE_ITEM';
export const REMOVE_MULTIPLE_LINE_ITEM = 'REMOVE_MULTIPLE_LINE_ITEM';
export const REMOVE_LINE_ITEM_SUCCESS = 'REMOVE_LINE_ITEM_SUCCESS';
export const REMOVE_LINE_ITEM_FAILURE = 'REMOVE_LINE_ITEM_FAILURE';
export const REMOVE_All_ITEM = 'REMOVE_All_ITEM';
export const REMOVE_All_ITEM_SUCCESS = 'REMOVE_All_ITEM_SUCCESS';
export const REMOVE_All_ITEM_FAILURE = 'REMOVE_All_ITEM_FAILURE';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const GET_CATEGORY = 'GET_CATEGORY';
export const CATEGORY_ERROR = 'CATEGORY_ERROR';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const GET_PRODUCT_SUGGESTIONS = 'GET_PRODUCT_SUGGESTIONS';
export const GET_I18N_CONTENT = 'GET_I18N_CONTENT';
export const GET_I18N_CONTENT_SUCCESS = 'GET_I18N_CONTENT_SUCCESS';
export const GET_I18N_CONTENT_FAILURE = 'GET_I18N_CONTENT_FAILURE';
export const RESET_I18N = 'RESET_I18N';
export const SHOW_CUSTOMIZATION_MODAL = 'SHOW_CUSTOMIZATION_MODAL';
export const RECOMMENDED_PRODUCT = 'RECOMMENDED_PRODUCT';
export const RECOMMENDED_PRODUCT_SUCCESS = 'RECOMMENDED_PRODUCT_SUCCESS';
export const RECOMMENDED_PRODUCT_FAILURE = 'RECOMMENDED_PRODUCT_FAILURE';
export const SAVE_DIMENSION = 'SAVE_DIMENSION';
export const CART_RECOMMENDATION_RULES = 'CART_RECOMMENDATION_RULES';
export const CART_RECOMMENDATION_RULES_SUCCESS = 'CART_RECOMMENDATION_RULES_SUCCESS';
export const CART_RECOMMENDATION_RULES_FAILURE = 'CART_RECOMMENDATION_RULES_FAILURE';
export const GET_APPLICABLE_COUPONS = 'GET_APPLICABLE_COUPONS';
export const GET_APPLICABLE_COUPONS_SUCCESS = 'GET_APPLICABLE_COUPONS_SUCCESS';
export const GET_APPLICABLE_COUPONS_FAILURE = 'GET_APPLICABLE_COUPONS_FAILURE';
export const APPLY_COUPONS = 'APPLY_COUPONS';
export const APPLY_COUPONS_SUCCESS = 'APPLY_COUPONS_SUCCESS';
export const APPLY_COUPONS_FAILURE = 'APPLY_COUPONS_FAILURE';
export const REMOVE_COUPONS = 'REMOVE_COUPONS';
export const REMOVE_COUPONS_SUCCESS = 'REMOVE_COUPONS_SUCCESS';
export const REMOVE_COUPONS_FAILURE = 'REMOVE_COUPONS_FAILURE';
export const ORDER_READY_DATETIME_UPDATE = 'ORDER_READY_DATETIME_UPDATE';
export const ORDER_READY_DATETIME_UPDATED_SUCCESS = 'ORDER_READY_DATETIME_UPDATED_SUCCESS';
export const ORDER_READY_DATETIME_UPDATED_ERROR = 'ORDER_READY_DATETIME_UPDATED_ERROR';
export const UPDATE_CUSTOMER_ID = 'UPDATE_CUSTOMER_ID';
export const UPDATE_CUSTOMER_ID_SUCCESS = 'UPDATE_CUSTOMER_ID_SUCCESS';
export const UPDATE_CUSTOMER_ID_FAILURE = 'UPDATE_CUSTOMER_ID_FAILURE';
export const UPDATE_BRAZE_SDK = 'UPDATE_BRAZE_SDK';
export const VALIDATE_BASKET_REQUEST = 'VALIDATE_BASKET_REQUEST';
export const VALIDATE_BASKET_SUCCESS = 'VALIDATE_BASKET_SUCCESS';
export const VALIDATE_BASKET_FAILURE = 'VALIDATE_BASKET_FAILURE';
export const VALIDATE_BASKET_RESET = 'VALIDATE_BASKET_RESET';
export const GET_NETBANKING_CONFIGURATIONS = 'GET_NETBANKING_CONFIGURATIONS';
export const GET_NETBANKING_CONFIGURATIONS_SUCCESS = 'GET_NETBANKING_CONFIGURATIONS_SUCCESS';
export const GET_NETBANKING_CONFIGURATIONS_FAILURE = 'GET_NETBANKING_CONFIGURATIONS_FAILURE';
export const CREATE_ORDER = 'CREATE_ORDER';
export const RESET_ORDER = 'RESET_ORDER';
export const CANCEL_POST_ORDER = 'CANCEL_POST_ORDER';
export const CANCEL_POST_ORDER_ERROR = 'CANCEL_POST_ORDER_ERROR';
export const CANCEL_POST_ORDER_SUCCESS = 'CANCEL_POST_ORDER_SUCCESS';
export const CHECK_IN_REQUEST = 'CHECK_IN_REQUEST';
export const CHECK_IN_REQUEST_ERROR = 'CHECK_IN_REQUEST_ERROR';
export const CHECK_IN_REQUEST_SUCCESS = 'CHECK_IN_REQUEST_SUCCESS';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';
export const GET_TENDERS_CONTENT = 'GET_TENDERS_CONTENT';
export const GET_TENDERS_CONTENT_SUCCESS = 'GET_TENDERS_CONTENT_SUCCESS';
export const GET_TENDERS_CONTENT_FAILURE = 'GET_TENDERS_CONTENT_FAILURE';
export const RESET_CART_DATA = 'RESET_CART_DATA';
export const FLAG_NON_LOCALIZED_ADD_TO_CART = 'FLAG_NON_LOCALIZED_ADD_TO_CART';
export const GIFTCARD_PURCHASE = 'GIFTCARD_PURCHASE';
export const GIFTCARD_PURCHASE_SUCCESS = 'GIFTCARD_PURCHASE_SUCCESS';
export const GIFTCARD_PURCHASE_FAILURE = 'GIFTCARD_PURCHASE_FAILURE';
export const RESET_PURCHASE = ' RESET_PURCHASE';
export const PAYMENT_USING_GIFTCARD = 'PAYMENT_USING_GIFTCARD';
export const PAYMENT_USING_GIFTCARD_SUCCESS = 'PAYMENT_USING_GIFTCARD_SUCCESS';
export const PAYMENT_USING_GIFTCARD_FAILURE = 'PAYMENT_USING_GIFTCARD_FAILURE';
export const CHECK_GIFTCARD_BALANCE = 'CHECK_GIFTCARD_BALANCE';
export const CHECKBALANCE_API_ERROR = 'CHECKBALANCE_API_ERROR';
export const CHECKBALANCE_SUCCESS = 'CHECKBALANCE_SUCCESS';
export const GET_GIFTCARD_DETAILS = 'GET_GIFTCARD_DETAILS';
export const GET_GIFTCARD_DETAILS_SUCCESS = 'GET_GIFTCARD_DETAILS_SUCCESS';
export const GET_GIFTCARD_DETAILS_FAILURE = 'GET_GIFTCARD_DETAILS_FAILURE';
export const PAYMENT_USING_NETBANKING = 'PAYMENT_USING_NETBANKING';
export const PAYMENT_USING_NETBANKING_SUCCESS = 'PAYMENT_USING_NETBANKING_SUCCESS';
export const PAYMENT_USING_NETBANKING_FAILURE = 'PAYMENT_USING_NETBANKING_FAILURE';
export const RESET_PAYMENT_STATUS = 'RESET_PAYMENT_STATUS';
export const GET_NON_LOCALISED_COUPON = 'GET_NON_LOCALISED_COUPON';
export const GET_NON_LOCALISED_COUPON_SUCCESS = 'GET_NON_LOCALISED_COUPON_SUCCESS';
export const GET_NON_LOCALISED_COUPON_FAILURE = 'GET_NON_LOCALISED_COUPON_FAILURE';
export const GET_LOGGEDIN_NON_LOCALISED_COUPON = 'GET_LOGGEDIN_NON_LOCALISED_COUPON';
export const GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS = 'GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS';
export const GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE = 'GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE';
export const GET_STORES = 'GET_STORES';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';
export const SET_GEOHASH_COUNT = 'SET_GEOHASH_COUNT';
export const SELECTED_DISPOSITION = 'SELECTED_DISPOSITION';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const PRIVACY_POLICY_ERROR = 'PRIVACY_POLICY_ERROR';
export const PRIVACY_POLICY_SUCCESS = 'PRIVACY_POLICY_SUCCESS';
export const GET_ADS = 'GET_ADS';
export const GET_ADS_ERROR = 'GET_ADS_ERROR';
export const GET_ADS_SUCCESS = 'GET_ADS_SUCCESS';
export const GET_GIFTCARD_CONTENT = 'GET_GIFTCARD_CONTENT';
export const GET_GIFTCARD_CONTENT_ERROR = 'GET_GIFTCARD_CONTENT_ERROR';
export const GET_GIFTCARD_CONTENT_SUCCESS = 'GET_GIFTCARD_CONTENT_SUCCESS';
export const SET_STORE_FAVOURITE = 'SET_STORE_FAVOURITE';
export const SET_STORE_UN_FAVOURITE = 'SET_STORE_UN_FAVOURITE';
export const SET_ITEM_FAVOURITE = 'SET_ITEM_FAVOURITE';
export const SET_ITEM_UN_FAVOURITE = 'SET_ITEM_UN_FAVOURITE';
export const SET_ITEM_FAVOURITE_SUCCESS = 'SET_ITEM_FAVOURITE_SUCCESS';
export const RESET_ITEM_FAVOURITE_SUCCESS = 'RESET_ITEM_FAVOURITE_SUCCESS';
export const SET_ITEM_UNFAVOURITE_SUCCESS = 'SET_ITEM_UNFAVOURITE_SUCCESS';
export const RESET_ITEM_UNFAVOURITE_SUCCESS = 'RESET_ITEM_UNFAVOURITE_SUCCESS';
export const LOADER_HIDE = 'LOADER_HIDE';
export const LOADER_SHOW = 'LOADER_SHOW';
export const RESET_FLAG_NON_LOCALIZED_ADD_TO_CART = 'RESET_FLAG_NON_LOCALIZED_ADD_TO_CART';
export const CART_RESET = 'CART_RESET';
export const GET_APP_UPDATE_CONTENT = 'GET_APP_UPDATE_CONTENT';
export const APP_UPDATE_CONTENT_SUCCESS = 'APP_UPDATE_CONTENT_SUCCESS';
export const APP_UPDATE_CONTENT_ERROR = 'APP_UPDATE_CONTENT_ERROR';
export const GET_APP_RATINGS_CONTENT = 'GET_APP_RATINGS_CONTENT';
export const APP_RATINGS_CONTENT_SUCCESS = 'APP_RATINGS_CONTENT_SUCCESS';
export const APP_RATINGS_CONTENT_ERROR = 'APP_RATINGS_CONTENT_ERROR';
export const GET_APP_CONFIGS = 'GET_APP_CONFIGS';
export const GET_APP_CONFIGS_SUCCESS = 'GET_APP_CONFIGS_SUCCESS';
export const CATEGORY_ITEM_INDEX = 'CATEGORY_ITEM_INDEX';
export const FULL_STORY_SESSION = 'fullStorySession';
export const UNAVAILABLE_MODIFIERS = 'UNAVAILABLE_MODIFIERS';
export const NA_SINGLE_ITEM = 'NA_SINGLE_ITEM';
export const NA_SINGLE_ITEM_ERROR = 'NA_SINGLE_ITEM_ERROR';
export const NA_SINGLE_ITEM_SUCCESS = 'NA_SINGLE_ITEM_SUCCESS';
export const GUEST_CONTENT_CHECKOUT = 'GUEST_CONTENT_CHECKOUT';
export const GET_GUEST_CONTENT_SUCCESS = 'GET_GUEST_CONTENT_SUCCESS';
export const GET_GUEST_CONTENT_FAILURE = 'GET_GUEST_CONTENT_FAILURE';
export const CATERING = 'catering';
export const FIND_A_KFC = 'FIND_A_KFC';
export const FIND_A_KFC_ERROR = 'FIND_A_KFC_ERROR';
export const FIND_A_KFC_SUCCESS = 'FIND_A_KFC_SUCCESS';
export const ADD_HOPE_THANK_YOU = 'addHopeThankYou';
export const FIELD_TITLE = 'fields.title';
export const ADD_HOPE = 'addHope';
export const FIELD_PAGE = 'fields.page';
export const Order_Tracking = 'OrderTracking';
export const Gift_Card = 'GiftCard';
export const DYNAMIC_MENU_ALERT_CONTENT = 'DYNAMIC_MENU_ALERT_CONTENT';
export const DYNAMIC_MENU_ALERT_SUCCESS = 'DYNAMIC_MENU_ALERT_SUCCESS';
export const DYNAMIC_MENU_ALERT_ERROR = 'DYNAMIC_MENU_ALERT_ERROR';
export const MODIFY_TIPPING_TOTAL = 'MODIFY_TIPPING_TOTAL';
export const GET_SPECIAL_EVENT_ITEM_AVAILABILITY = 'GET_SPECIAL_EVENT_ITEM_AVAILABILITY';
export const GET_SPECIAL_EVENT_ITEM_AVAILABILITY_SUCCESS = 'GET_SPECIAL_EVENT_ITEM_AVAILABILITY_SUCCESS';
export const GET_SPECIAL_EVENT_ITEM_AVAILABILITY_ERROR = 'GET_SPECIAL_EVENT_ITEM_AVAILABILITY_ERROR';
